import React from 'react';
import './animate4.less';

const Animate4: React.FC = () => {
    return <div className="c-animate4"></div>;
};

export default Animate4;
